import { useSnackbar } from "notistack";

export const useNotify = () => {
  const { enqueueSnackbar } = useSnackbar();

  const notify = (message, type = "default") => {
    enqueueSnackbar(message, { variant: type });
  };

  const showSuccess = (message) => {
    notify(message, "success");
  };

  const showError = (message) => {
    notify(message, "error");
  };

  const showWarning = (message) => {
    notify(message, "warning");
  };

  const showInfo = (message) => {
    notify(message, "info");
  };

  // Special handler for API errors
  const handleApiError = (err) => {
    if (err?.errors?.length) {
      showError(err.errors[0].message);
    } else {
      showError("Server problem, try after sometime.");
    }
  };

  return {
    notify,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    handleApiError,
  };
};
